<div class="filter-tag d-flex align-items-center px-2 me-2 mt-2">
  <span class="caption c-blue me-2">{{ text }}</span>
  <lib-elux-icon [icon]="icon" [size]="iconSize" (click)="click()" />
</div>
